<div class="login-wrapper">
  <app-loader [isLoading]="isLoading"></app-loader>
  <div class="login-container">
    <form (ngSubmit)="onSubmit()" class="form" [formGroup]="loginForm">
      <h1>Bem-vindo, cliente!</h1>
      <div class="form-group">
        <app-input
          label="Email"
          name="TX_MAIL_EXTR"
          formControlName="TX_MAIL_EXTR"
          placeholder="exemplo@email.com.br"></app-input>
        <app-input
          type="password"
          label="Senha"
          name="TX_SENH_EXTR"
          formControlName="TX_SENH_EXTR"
          placeholder="Digite aqui"></app-input>
      </div>
      <div class="checkbox-container">
        <label class="forgot-password" (click)="goTo('/recuperar-senha')"
          >Esqueceu a senha?</label
        >
      </div>
      <app-botao
        class="button"
        type="primario"
        width="100%"
        text="Entrar"
        (click)="onSubmit()"></app-botao>

      <app-botao
        class="button"
        type="secundario"
        width="100%"
        text="Cadastrar usuário"
        (click)="goTo('/cadastro-usuario')"></app-botao>
    </form>
    <p>
      Ao acessar, você concorda com os nossos
      <a href="#" id="link-termo-uso">termo de uso</a> e
      <a href="#" id="link-termo-consentimento">termo de consentimento</a>.
    </p>
  </div>

  <div class="image-container">
    <img src="assets/LogoLavaLog.svg" />
  </div>
</div>
